/**
 * True for phones and tablets (including iPadOS, which masquerades as a Mac).
 * Used to gate experiences that only work on a desktop browser — distinct from
 * layout breakpoints like useIsMobile(), which only measure window width.
 */
export const isMobileDevice = (): boolean => {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent;
  const uaMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobi/i.test(ua);
  // iPadOS 13+ reports a desktop Mac UA; the touch points give it away.
  const iPadOS = /Macintosh/.test(ua) && navigator.maxTouchPoints > 1;
  return uaMobile || iPadOS;
};
